import { Accordion, AccordionDetails, AccordionSummary, Box, Typography, useMediaQuery, useTheme } from "@mui/material";
import { FormattedMessage } from "react-intl";
import { AppButton, AppButtonStyles } from "dsoneweb.designsystem";
import { Updater } from "../../components/Updater";
import { ExpandMore as ExpandMoreIcon } from "@mui/icons-material";
import { useState } from "react";
import { IDeviceInfo } from "model/scan/DeviceInfo";
import { IDriverUpdateModel } from "model/driver/DriverUpdateModel";
import styled from "@mui/styled-engine";

export const defaultImageDevice =
  "data:image/png;base64,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";

const StyledAccordion = styled(Accordion)`
  border-top: 1px solid #ebecf2;
  width: 100%;

  .MuiAccordionSummary-root {
    padding: 0;
  }
`;
const StyledAccordionSummary = styled(AccordionSummary)`
  &:before {
    display: "none";
  }
  .MuiAccordionSummary-content {
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin: 16px 0;
    width: 100%;

    ${({ theme }) => theme.breakpoints.up("md")} {
      flex-direction: row;
      gap: 8px;
      justify-content: space-between;
    }
  }
`;
const NameAndImageContainer = styled(Box)`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 16px;

  img {
    width: 120px;
  }

  ${({ theme }) => theme.breakpoints.up("md")} {
    flex-direction: row;
    gap: 20px;
  }

  ${({ theme }) => theme.breakpoints.up("lg")} {
    gap: 32px;
  }
`;
const DriverNameAndStatusContainer = styled(Box)`
  align-items: center;
  display: flex;
  flex-direction: column;

  ${({ theme }) => theme.breakpoints.up("md")} {
    align-items: flex-start;
  }
`;
const CTAContainer = styled(Box)`
  align-items: center;
  display: flex;
  justify-content: center;
  width: 220px;
`;
const CollapsedContent = styled(Box)`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 16px;
  justify-content: space-between;
  margin: 16px 27.42px 16px 0;

  ${({ theme }) => theme.breakpoints.up("md")} {
    flex-direction: row;
    margin-left: 140px; // to offset the image
  }

  ${({ theme }) => theme.breakpoints.up("lg")} {
    margin-left: 152px;
  }
`;
const TextContainer = styled(Box)`
  align-items: center;
  display: flex;
  flex-direction: column;

  ${({ theme }) => theme.breakpoints.up("md")} {
    align-items: flex-start;
  }
`;
const StyledTypography = styled(Typography)`
  font-size: 1rem;
  font-weight: 600;
`;

const OrangeText = styled(StyledTypography)`
  color: #f1582d;
`;
const GreenText = styled(StyledTypography)`
  color: #0ca15d;
`;
const BiggerGrayText = styled(Typography)`
  color: #535a6a;
  font-size: 1.125rem;
  font-weight: 600;
`;

export interface IDeviceProps {
  device: IDeviceInfo;
  driverUpdateModel: IDriverUpdateModel | null;
  isAgentLocal: boolean;
  onDownload: () => void;
  onInstall: () => void;
  onAbout: () => void;
  onDownloadCancel: () => void;
  onDownloadRetry: () => void;
}

export function Device({
  device,
  driverUpdateModel,
  isAgentLocal,
  onDownload,
  onInstall,
  onAbout,
  onDownloadCancel,
  onDownloadRetry,
}: IDeviceProps) {
  const image = device.deviceImageURI ? device.deviceImageURI : device.logoBase64 || defaultImageDevice;

  let deviceDescription: string = device.description;

  if (deviceDescription.length > 40) {
    deviceDescription = deviceDescription.slice(0, 40) + "...";
  }
  const [isExpanded, setIsExpanded] = useState(device.hasUpdateAvailable);
  const theme = useTheme();
  const largeScreen = useMediaQuery(theme.breakpoints.up("md"));
  const CallToActionSection = () => {
    if (device.hasUpdateAvailable && driverUpdateModel) {
      return (
        <CTAContainer
          data-qatag="driver.device_entry.header.update_container"
          id="driver.device_entry.header.update_container"
        >
          <Updater
            data-qatag="driver.device_entry.header.updater"
            statusModel={driverUpdateModel}
            isAgentLocal={isAgentLocal}
            onDownload={onDownload}
            onUpdate={onInstall}
            onDownloadCancel={onDownloadCancel}
            onDownloadRetry={onDownloadRetry}
          />
        </CTAContainer>
      );
    }

    return null;
  };

  return (
    <>
      <StyledAccordion
        data-qatag="device-details"
        disableGutters
        elevation={0}
        expanded={isExpanded}
        onChange={() => setIsExpanded(!isExpanded)}
      >
        <StyledAccordionSummary
          data-qatag="device-details-summary"
          expandIcon={<ExpandMoreIcon data-qatag="ExpandMoreIcon" />}
          aria-controls="device-details-summary-content"
          id="device-details-summary"
        >
          <NameAndImageContainer data-qatag="nameAndImageContainer">
            <img
              data-qatag="driver.device_entry.device_image"
              id="driver.device_entry.device_image"
              src={image}
              alt={device.categoryName}
            />
            <DriverNameAndStatusContainer data-qatag="DriverNameAndStatusContainer">
              <BiggerGrayText
                data-qatag="driver.device_entry.friendly_name.text"
                id="driver.device_entry.friendly_name.text"
                variant="h6"
              >
                {device.friendlyName}
              </BiggerGrayText>
              {device.hasUpdateAvailable && driverUpdateModel != null ? (
                <OrangeText
                  data-qatag="driver.device_entry.header.out_of_date.text"
                  id="driver.device_entry.header.out_of_date.text"
                  variant="body2"
                >
                  <FormattedMessage
                    data-qatag="driver.device_entry.header.out_of_date"
                    id="driver.device_entry.header.out_of_date"
                    defaultMessage="Out of date"
                  />
                </OrangeText>
              ) : (
                <GreenText
                  data-qatag="driver.device_entry.header.out_of_date.text"
                  id="driver.device_entry.header.out_of_date.text"
                  variant="body2"
                >
                  <FormattedMessage
                    data-qatag="driver.device_entry.header.out_of_date"
                    id="driver.device_entry.header.out_of_date"
                    defaultMessage="Up to date"
                  />
                </GreenText>
              )}
            </DriverNameAndStatusContainer>
          </NameAndImageContainer>
          {!isExpanded || largeScreen ? <CallToActionSection data-qatag="device-details-summary-info-cta" /> : null}
        </StyledAccordionSummary>
        <AccordionDetails
          data-qatag="device-details-summary-info"
          sx={{ padding: 0 }}
        >
          <CollapsedContent data-qatag="device-details-summary-info-collapsed-content">
            <TextContainer
              data-qatag="driver.device_entry.content.meta.container"
              id="driver.device_entry.content.meta.container"
            >
              <Typography
                data-qatag="driver.device_entry.content.meta.device_description.text"
                id="driver.device_entry.content.meta.device_description.text"
                variant="body2"
                color="primary"
              >
                <FormattedMessage
                  data-qatag="driver.device_entry.content.meta.device_description"
                  id="driver.device_entry.content.meta.device_description"
                  defaultMessage="<strong>Device Description</strong>: {desc}"
                  values={{
                    desc: deviceDescription,
                    strong: (chunks) => <strong data-qatag="strong">{chunks}</strong>,
                  }}
                />
              </Typography>

              {/* ip address for network printers */}
              {device.localIP && (
                <Typography
                  data-qatag="driver.device_entry.content.meta.ip.text"
                  id="driver.device_entry.content.meta.ip.text"
                  variant="body2"
                  color="primary"
                >
                  <FormattedMessage
                    data-qatag="driver.device_entry.content.meta.ip"
                    id="driver.device_entry.content.meta.ip"
                    defaultMessage="<strong>IP Address</strong>: {ip}"
                    values={{
                      ip: device.localIP,
                      strong: (chunks) => <strong data-qatag="strong">{chunks}</strong>,
                    }}
                  />
                </Typography>
              )}

              <Typography
                data-qatag="driver.device_entry.content.meta.installed_version.value"
                id="driver.device_entry.content.meta.installed_version.value"
                variant="body2"
                color="primary"
              >
                <FormattedMessage
                  data-qatag="driver.device_entry.content.meta.installed_version"
                  id="driver.device_entry.content.meta.installed_version"
                  defaultMessage="<strong>Installed Version</strong>: {version}"
                  values={{
                    version: device.installedDriverVersion,
                    strong: (chunks) => <strong data-qatag="strong">{chunks}</strong>,
                  }}
                />
              </Typography>

              <Typography
                data-qatag="driver.device_entry.content.meta.latest_driver_date.text"
                id="driver.device_entry.content.meta.latest_driver_date.text"
                variant="body2"
                color="primary"
              >
                <FormattedMessage
                  data-qatag="driver.device_entry.content.meta.latest_driver_date"
                  id="driver.device_entry.content.meta.latest_driver_date"
                  defaultMessage="<strong>Latest Driver Date</strong>: {driverDate}"
                  values={{
                    driverDate: device.latestDriverDate,
                    strong: (chunks) => <strong data-qatag="strong">{chunks}</strong>,
                  }}
                />
              </Typography>

              {/* only show file size if there's an update */}
              {device.hasUpdateAvailable && device.latestDriverFileSize ? (
                <Typography
                  data-qatag="driver.device_entry.content.meta.driver_size.text"
                  id="driver.device_entry.content.meta.driver_size.text"
                  variant="body2"
                  color="primary"
                >
                  <FormattedMessage
                    data-qatag="driver.device_entry.content.meta.driver_size"
                    id="driver.device_entry.content.meta.driver_size"
                    defaultMessage="<strong>File Size</strong>: {fileSize}"
                    values={{
                      fileSize: device.latestDriverFileSize,
                      strong: (chunks) => <strong data-qatag="strong">{chunks}</strong>,
                    }}
                  />
                </Typography>
              ) : null}
            </TextContainer>
            {!largeScreen ? <CallToActionSection data-qatag="device-details-summary-info-cta" /> : null}
            <CTAContainer data-qatag="driver.device_entry.content.question">
              <AppButton
                ariaLabel="Question about this device"
                buttonType="button"
                data-qatag="driver.device_entry.content.aboutButton"
                id="driver.device_entry.content.aboutButton"
                buttonStyle={AppButtonStyles.LinkBlue}
                onClick={onAbout}
              >
                <OrangeText
                  data-qatag="driver.device_entry.content.aboutButton.content.text"
                  id="driver.device_entry.content.aboutButton.content.text"
                  variant="body1"
                >
                  <FormattedMessage
                    data-qatag="driver.device_entry.content.aboutButton.content"
                    id="driver.device_entry.content.aboutButton.content"
                    defaultMessage="Question About This Device"
                  />
                </OrangeText>
              </AppButton>
            </CTAContainer>
          </CollapsedContent>
        </AccordionDetails>
      </StyledAccordion>
    </>
  );
}
//#endregion Component
